<script setup lang="ts">
import { ASSETS, LX_BIDS, WHY_MLIVE } from './constants'
</script>

<template>
  <section
    id="whyMliveSection"
    class="why-mlive-section"
    :data-mv-bid="LX_BIDS.whyMliveMv"
    data-mv-key="why-mlive"
    :data-mv-module-identifier="2"
  >
    <!-- 桌面端：保持原绝对定位布局 -->
    <div class="why-mlive-layout why-mlive-desktop">
      <div class="section-heading">
        <div class="section-title">
          <span>为什么选择</span>
          <span class="accent">美团智播？</span>
        </div>
        <div class="section-sub">官方服务、更懂商品、更懂经营，让本地生活直播更高效</div>
      </div>

      <div class="why-mlive-grid">
        <!-- 列1 -->
        <article class="why-card pos-local">
          <div class="why-card-title">{{ WHY_MLIVE[0].title }}</div>
          <div class="why-card-desc">{{ WHY_MLIVE[0].description }}</div>
        </article>
        <img
          class="why-media pos-media-mid"
          :src="ASSETS.whyMliveMediaMid"
          alt=""
          aria-hidden="true"
        >
        <article class="why-card pos-support">
          <div class="why-card-title">{{ WHY_MLIVE[2].title }}</div>
          <div class="why-card-desc">{{ WHY_MLIVE[2].description }}</div>
        </article>
        <img
          class="why-media pos-media-bottom"
          :src="ASSETS.whyMliveMediaBottom"
          alt=""
          aria-hidden="true"
        >

        <!-- 列0.5 -->
        <article class="why-card pos-product">
          <div class="why-card-title">{{ WHY_MLIVE[1].title }}</div>
          <div class="why-card-desc">{{ WHY_MLIVE[1].description }}</div>
        </article>
        <img
          class="why-media pos-media-product"
          :src="ASSETS.whyMliveMediaProduct"
          alt=""
          aria-hidden="true"
        >

        <!-- 列0 -->
        <article class="why-card pos-exposure">
          <div class="why-card-title">{{ WHY_MLIVE[4].title }}</div>
          <div class="why-card-desc">{{ WHY_MLIVE[4].description }}</div>
        </article>

        <!-- 列2 -->
        <article class="why-card pos-platform">
          <div class="why-card-title">{{ WHY_MLIVE[3].title }}</div>
          <div class="why-card-desc">{{ WHY_MLIVE[3].description }}</div>
        </article>
      </div>
    </div>

    <!-- 移动端：按设计稿 1452502 双列错落（图片占位，后续可替换） -->
    <div class="why-mlive-mobile">
      <div class="mobile-cols">
        <div class="mobile-col mobile-col-left">
          <div class="section-heading">
            <div class="section-title">
              <span>为什么选择</span>
              <span class="accent">美团智播？</span>
            </div>
            <div class="section-sub">官方服务、更懂商品、更懂经营，让本地生活直播更高效</div>
          </div>
          <article class="why-card">
            <div class="why-card-title">{{ WHY_MLIVE[4].title }}</div>
            <div class="why-card-desc">{{ WHY_MLIVE[4].description }}</div>
          </article>
          <img
            class="why-media"
            :src="ASSETS.whyMliveMediaProduct"
            alt=""
            aria-hidden="true"
          >
          <article class="why-card">
            <div class="why-card-title">{{ WHY_MLIVE[1].title }}</div>
            <div class="why-card-desc">{{ WHY_MLIVE[1].description }}</div>
          </article>
        </div>

        <div class="mobile-col mobile-col-right">
          <img
            class="why-media"
            :src="ASSETS.whyMliveMediaMid"
            alt=""
            aria-hidden="true"
          >
          <article class="why-card">
            <div class="why-card-title">{{ WHY_MLIVE[0].title }}</div>
            <div class="why-card-desc">{{ WHY_MLIVE[0].description }}</div>
          </article>
          <article class="why-card">
            <div class="why-card-title">{{ WHY_MLIVE[2].title }}</div>
            <div class="why-card-desc">{{ WHY_MLIVE[2].description }}</div>
          </article>
          <article class="why-card">
            <div class="why-card-title">{{ WHY_MLIVE[3].title }}</div>
            <div class="why-card-desc">{{ WHY_MLIVE[3].description }}</div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.why-mlive-section {
  width: 1200px;
  max-width: calc(100% - 48px);
  margin: 160px auto 0;
}

.why-mlive-layout {
  position: relative;
  min-height: 836px;
}

.section-heading {
  position: absolute;
  z-index: 2;
  top: 29px;
  left: 18px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 526px;
  max-width: calc(100% - 40px);
}

.section-title {
  display: flex;
  gap: 24px;
  color: #171717;
  font-size: 48px;
  font-weight: 700;
  line-height: normal;
}

.accent {
  color: #8932ff;
}

.section-sub {
  color: #666;
  font-size: 18px;
  font-weight: 300; /* L */
  line-height: 1.47;
}

.why-mlive-grid {
  position: relative;
  height: 836px;
}

.why-card {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 286px;
  min-height: 185px;
  padding: 32px 24px;
  border-radius: 24px;
  background: #f7f7f7;
  box-sizing: border-box;
}

.why-card-title {
  color: #171717;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
}

.why-card-desc {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
}

.why-media {
  position: absolute;
  width: 286px;
  height: 185px;
  border-radius: 24px;
  object-fit: cover;
  background: #f0f0f0;
}

.pos-local {
  left: 615px;
  top: 0;
  width: 281px;
}

.pos-media-mid {
  left: 615px;
  top: 217px;
}

.pos-support {
  left: 615px;
  top: 434px;
}

.pos-media-bottom {
  left: 615px;
  top: 651px;
}

.pos-product {
  left: 310px;
  top: 217px;
}

.pos-media-product {
  left: 310px;
  top: 434px;
}

.pos-exposure {
  left: 0;
  top: 434px;
}

.pos-platform {
  left: 919px;
  top: 217px;
  width: 281px;
}

.why-mlive-mobile {
  display: none;
}

@media (max-width: 1100px) {
  .why-mlive-section {
    width: auto;
    max-width: none;
    margin: 64px 20px 0;
  }

  .why-mlive-desktop {
    display: none;
  }

  .why-mlive-mobile {
    display: block;
  }

  .mobile-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    align-items: start;
  }

  .mobile-col {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .why-mlive-mobile .section-heading {
    position: static;
    width: auto;
    max-width: none;
    gap: 12px;
    margin-bottom: 4px;
  }

  .why-mlive-mobile .section-title {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 4px;
    font-size: 28px;
  }

  .why-mlive-mobile .section-sub {
    font-size: 12px;
    line-height: 1.47;
  }

  .why-mlive-mobile .why-card {
    position: static;
    width: 100%;
    min-height: 0;
    gap: 10px;
    padding: 16px 14px;
    border-radius: 16px;
  }

  .why-mlive-mobile .why-card-title {
    font-size: 15px;
  }

  .why-mlive-mobile .why-card-desc {
    font-size: 12px;
    font-weight: 300;
  }

  .why-mlive-mobile .why-media {
    position: static;
    width: 100%;
    height: auto;
    aspect-ratio: 335 / 216;
    border-radius: 16px;
  }
}
</style>
